import "./native-bridge";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { clearLegacySensitiveTenantStorage } from "./lib/tenantStorage";
import { recordClientCrash } from "./lib/clientRecovery";
import { browserLanguages, loadLocalePreference, resolveLocalePreference } from "./lib/localePreference";
import { visualViewportHeight } from "./lib/visualViewportMetrics";

// iOS Chrome, Safari and every other browser use WebKit, while modern iPadOS
// can identify itself as a touch-enabled Mac. Mark that device family before
// React renders any form control so iOS-only viewport rules never spill into
// the Android WebView or desktop layouts.
try {
  const iOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  if (iOSDevice) document.documentElement.dataset.servernoxIos = "true";
} catch {}

window.addEventListener("error", (event) => {
  recordClientCrash(event.error || event.message, "window-error");
});
window.addEventListener("unhandledrejection", (event) => {
  recordClientCrash(event.reason, "unhandled-rejection");
});

// Eski sürümün hesaptan bağımsız tuttuğu hassas terminal/API
// önbelleklerini React bunları okumadan önce kaldır.
try { clearLegacySensitiveTenantStorage(); } catch {}

// Dil tercihini ilk React render'ından önce uygula; böylece mobil/WebView'da
// dil seçimi ekran açılırken de kaybolmaz.
try {
  document.documentElement.lang = resolveLocalePreference(
    loadLocalePreference(),
    browserLanguages(),
  );
} catch {}

// Android WebView ve mobil tarayıcılarda sanal klavye CSS'teki 100dvh
// değerini her zaman güncellemez. Görünen gerçek viewport'u tek bir CSS
// değişkenine aktar; editörler ve modallar klavyenin arkasında kalmasın.
(function syncVisualViewportHeight() {
  const viewport = window.visualViewport;
  const update = () => {
    const height = visualViewportHeight(viewport, window.innerHeight);
    document.documentElement.style.setProperty(
      "--app-visual-height",
      `${Math.round(height)}px`,
    );
  };
  update();
  window.addEventListener("resize", update);
  viewport?.addEventListener("resize", update);
  // visualViewport scroll fires while iOS is merely panning the focused
  // field. Height has not changed; recalculating the whole shell there makes
  // a bottom composer visibly bounce. Keyboard open/close is a resize.
})();

// Yükleme çubuğunu başlat
(function () {
  var el = document.getElementById("scp-progress");
  if (!el) return;
  el.classList.add("active");
  requestAnimationFrame(function () {
    el!.style.transition = "width .3s ease, opacity .3s ease";
    el!.style.width = "70%";
  });
})();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
(window as Window & { __SERVERNOX_BOOTED__?: boolean }).__SERVERNOX_BOOTED__ = true;

// React render tamamlandı — splash'ı kapat
(function () {
  var _start = Date.now();
  function hideSplash() {
    var splash = document.getElementById("scp-splash");
    if (splash) splash.classList.add("splash-hidden");
    var bar = document.getElementById("scp-progress");
    if (bar) {
      bar.style.width = "100%";
      setTimeout(function () {
        bar!.style.opacity = "0";
        setTimeout(function () {
          bar!.classList.remove("active");
          bar!.style.width = "0";
          bar!.style.opacity = "";
        }, 300);
      }, 250);
    }
  }
  var delay = Math.max(0, 500 - (Date.now() - _start));
  setTimeout(hideSplash, delay);
  // page transitions
  window.addEventListener("beforeunload", function () {
    var el = document.getElementById("scp-progress");
    if (!el) return;
    el.classList.add("active");
    el.style.width = "70%";
  });
})();
